import {
  Box,
  Button,
  Divider,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { FC, useEffect, useRef, useState } from "react";
import ThumbUpAltIcon from "@mui/icons-material/ThumbUpAlt";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import { useAppDispatch, useAppSelecter } from "../../hooks/storeHooks";
import { loadQuestionsDataArray } from "../../store/slices/proofReading/thunks/loadQuestionsDataArray/loadQuestionDataArray";
import mathFunction from "../../pages/exams/mathFunction";
import { useNavigate, useLocation } from "react-router-dom";
//import { logoutUser } from "../store/slices/userDataSlice/thunks/logoutUser/logoutUser";
import globalColors from "../../globalColors";
import { setActiveQuestion } from "../../store/slices/proofReading/questionDataArraySlice";
import CustomProgress from "../CustomProgress";
import IconInfo from "./IconInfo";
import Preview from "./Preview";

export const QuestionsContainer: FC = () => {
  const dispatch = useAppDispatch();

  const questionsRef = useRef(null);
  const { status, questionsDataArray } = useAppSelecter(
    (state) => state.questionsDataArraySlice
  );

  const { activeQuestionData } = useAppSelecter(
    (state) => state.questionsDataArraySlice
  );

  const token = localStorage.getItem("npc-admin-token")
    ? JSON.parse(localStorage.getItem("npc-admin-token") || "")
    : null;
  const [filterby, setFilterBy] = useState("all");
  const [questionIds, setQuestionIds] = useState("");

  // useEffect(() => {
  // if (questionsDataArray === null && status === "IDLE")
  // handleLoadQuestiondDataArray({ currentPageNumber: 1 });
  // }, []);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (
      location.pathname.includes("/preview/") &&
      location.pathname.includes("/editor")
    ) {
      navigate("/proofReading", { replace: true });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  // useEffect(() => {
  //   handleLoadQuestiondDataArray({ currentPageNumber });
  // }, [currentPageNumber]);
  useEffect(() => {
    handleLoadQuestiondDataArray();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    mathFunction();
    let timeOut: ReturnType<typeof setTimeout>;

    if (questionsRef.current) {
      timeOut = setTimeout(() => mathFunction(), 500);
    }

    return () => clearTimeout(timeOut);
  }, [questionsDataArray, filterby]);

  const handleLoadQuestiondDataArray = async (questionIdsParam?: string) => {
    try {
      if (token === null) return;
      const dispatchLoadQuestionsDataArrayResponse: any = await dispatch(
        loadQuestionsDataArray({ token, questionIds: questionIdsParam })
      );

      if (
        dispatchLoadQuestionsDataArrayResponse.meta.requestStatus === "rejected"
      )
        throw new Error(dispatchLoadQuestionsDataArrayResponse.error.message);
    } catch (error: any) {
      alert(error.message);
      //dispatch(logoutUser());
    }
  };
  const [modalInfo, setModalInfo] = useState<{
    visible: boolean;
  }>({
    visible: false,
  });
  const handleFilterChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setFilterBy((event.target as HTMLInputElement).value);
  };

  // if (questionsDataArray === null) return null;

  const filteredQuestionsDataArray =
    questionsDataArray === null
      ? []
      : filterby === "all"
      ? questionsDataArray
      : questionsDataArray.filter(
          (questionsData) => questionsData.editStatus === filterby
        );
  return (
    <Stack sx={{ height: "100%", width: "100%" }}>
      {/* Question IDs Input */}
      <Stack direction="row" spacing={2} p={"16px 16px 0 16px"} alignItems="center">
        <TextField
          fullWidth
          size="small"
          label="Question IDs (comma-separated)"
          placeholder="e.g., 17769,17768,17766"
          value={questionIds}
          onChange={(e) => setQuestionIds(e.target.value)}
        />
        <Button
          variant="contained"
          sx={{ textTransform: "capitalize", minWidth: "100px" }}
          onClick={() => handleLoadQuestiondDataArray(questionIds)}
          disabled={status === "LOADING"}
        >
          Fetch
        </Button>
      </Stack>
      {/* filters */}
      <Stack marginTop={"2px"} p={"16px 16px 0 16px"}>
        <FormControl>
          <FormLabel sx={{ color: "#1f2937", fontWeight: 600 }}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                width: "100%",
              }}
            >
              Question Filters{" "}
              <Box
                sx={{
                  cursor: "pointer",
                  textDecoration: "underline",
                  fontWeight: 400,
                }}
                onClick={() => {
                  setModalInfo({ visible: true });
                }}
              >
                See What You Reviewed
              </Box>
            </Box>
            <p style={{ color: "#6b7280", fontWeight: 400, margin: "0" }}>
              based on their proofreading status{" "}
              {(questionsDataArray === null
                ? 0
                : questionsDataArray.filter(
                    (questionsData) => questionsData.editStatus === "completed"
                  ).length) > 0 ? (
                <IconInfo />
              ) : (
                ""
              )}
            </p>
            {modalInfo.visible ? (
              <Preview
                onClose={() => {
                  setModalInfo({ visible: false });
                }}
              />
            ) : (
              ""
            )}
          </FormLabel>
          <RadioGroup
            row
            aria-labelledby="demo-row-radio-buttons-group-label"
            name="row-radio-buttons-group"
            value={filterby}
            onChange={handleFilterChange}
          >
            <FormControlLabel
              sx={{ marginRight: "7px" }}
              value="all"
              control={<Radio />}
              label={`All (${
                questionsDataArray === null ? 0 : questionsDataArray.length
              })`}
            />
            <FormControlLabel
              sx={{ marginRight: "7px" }}
              value="pending"
              control={<Radio />}
              label={`Pending (${
                questionsDataArray === null
                  ? 0
                  : questionsDataArray.filter(
                      (questionsData) => questionsData.editStatus === "pending"
                    ).length
              })`}
            />
            <FormControlLabel
              value="completed"
              sx={{ marginRight: "0" }}
              control={<Radio />}
              label={`Completed (${
                questionsDataArray === null
                  ? 0
                  : questionsDataArray.filter(
                      (questionsData) =>
                        questionsData.editStatus === "completed"
                    ).length
              })`}
            />
          </RadioGroup>
        </FormControl>
      </Stack>

      <Divider sx={{ margin: "0 16px", width: "calc(100% - 32px)" }} />
      {/* questions list */}
      <List
        ref={questionsRef}
        className="scrollBluePrimarythin"
        sx={{
          overflowY: "auto",
          height: "calc(100% - 96.18px)",
          //  145.31px)",
          minHeight: "calc(100% - 96.18px)",
          padding: "0",
        }}
      >
        {status === "LOADING" ? (
          <Box
            sx={{
              height: "100%",
              width: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <CustomProgress
              sx={{ height: "30px !important", width: "30px !important" }}
            />
          </Box>
        ) : filteredQuestionsDataArray.length === 0 ? (
          <Box
            sx={{
              flex: "8",
              justifyContent: "center",
              alignItems: "center",
              display: "flex",
              height: "100%",
            }}
          >
            <Typography variant="body1">No Questions Found</Typography>
          </Box>
        ) : (
          filteredQuestionsDataArray.map((questionData, i) => (
            <>
              <ListItem
                disablePadding
                key={questionData.questionId}
                sx={{
                  bgcolor:
                    activeQuestionData !== null &&
                    activeQuestionData?.questionId === questionData.questionId
                      ? globalColors.lavender[200]
                      : "",
                }}
              >
                <ListItemButton
                  onClick={(e) => {
                    e.stopPropagation();

                    dispatch(
                      setActiveQuestion({
                        activeQuestionRowNumber: questionData.questionId,
                      })
                    );
                    navigate(`preview/${questionData.questionId}/editor`);
                  }}
                >
                  <ListItemText
                    sx={{ margin: "0" }}
                    primary={
                      <Stack direction={"row"} spacing={"16px"}>
                        <span
                          style={{
                            minWidth: "40px",
                            display: "flex",
                            flexDirection: "column",
                            gap: "2px",
                            textAlign: "center",
                          }}
                        >
                          {questionData.questionId}
                          {questionData.editStatus === "completed" ? (
                            questionData.corrections !== null &&
                            Object.values(questionData.corrections).some(
                              (state) => state
                            ) ? (
                              <Box
                                sx={{
                                  display: "flex",
                                  justifyContent: "center",
                                }}
                              >
                                <CheckCircleIcon
                                  sx={{
                                    color: "green",
                                    height: "18px",
                                    width: "18px",
                                  }}
                                />
                              </Box>
                            ) : (
                              <Box
                                sx={{
                                  display: "flex",
                                  justifyContent: "center",
                                }}
                              >
                                <ThumbUpAltIcon
                                  sx={{
                                    color: "green",
                                    height: "18px",
                                    width: "18px",
                                  }}
                                />
                              </Box>
                            )
                          ) : (
                            ""
                          )}
                        </span>
                        <Typography
                          sx={{
                            "& > :nth-child(1) p:first-of-type": {
                              margin: "0 !important",
                            },
                            "& > :nth-child(2) p:first-of-type": {
                              margin: "0 !important",
                            },
                            "& > :nth-child(1) p": {
                              margin: "0 !important",
                            },
                            "& > :first-child": {
                              margin: "0 !important",
                              "& > :first-child": {
                                margin: "0 !important",
                              },
                              "& > :second-child": {
                                margin: "0 !important",
                              },
                            },
                          }}
                        >
                          <div
                            dangerouslySetInnerHTML={{
                              __html: questionData.question,
                            }}
                          ></div>
                        </Typography>
                      </Stack>
                    }
                  />
                </ListItemButton>
              </ListItem>
              {i + 1 !== filteredQuestionsDataArray.length && (
                <Divider
                  sx={{ margin: "0 16px", width: "calc(100% - 32px)" }}
                />
              )}
            </>
          ))
        )}
      </List>
      {/* page navigators */}

      {/* <
      Divider sx={{ margin: "0 16px", width: "calc(100% - 32px)" }} /> */}
      {/* <Stack
        direction={"row"}
        justifyContent={"space-between"}
        px={"16px"}
        my="5px"
      >
        <Button
          variant="contained"
        sx={{textTransform:"capitalize"}}
          disabled={currentPageNumber === 1 || status === "LOADING"}
          onClick={(e) => {
            e.stopPropagation();
            dispatch(goToPreviousPage());
          }}
        >
          previous
        </Button>
        <Typography
          textAlign={"center"}
          m="0"
          alignItems={"center"}
          display={"flex"}
        >
          {currentPageNumber}/10
        </Typography>
        <Button
          variant="contained"
        sx={{textTransform:"capitalize"}}
          disabled={currentPageNumber === 10 || status === "LOADING"}
          onClick={(e) => {
            e.stopPropagation();
            dispatch(goToNextPage());
          }}
        >
          next
        </Button>
      </Stack> */}
    </Stack>
  );
};
